import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Notification, NotificationAlertType, NotificationTranslations, NotificationType } from 'ah-api-gateways';
import { formatDistance, isToday, isYesterday } from 'date-fns';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';

/**
 * Notification component
 *
 * TODO: currently `view-resource` event is only triggered for custom-created software update notification, to allow opening modal
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationCard',
  props: {
    notification: null,
    loading: { type: [Boolean, String] }
  },
  emits: ["open-resource"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'open-resource', notification: Notification): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  notification: Notification;
  /**
   * Loading state for the Open Resource button
   */
  loading?: boolean | string;
};





const notificationTitle = computed(
  () => props.notification.title || NotificationTranslations[props.notification.type] || 'N/A'
);

const isFileExportedNotification = computed(
  () => props.notification.type === NotificationType.DOCUMENT_STATUS_EXPORTED
);

function formatDate(date: string) {
  if (isToday(new Date(date))) {
    return 'TODAY';
  } else if (isYesterday(new Date(date))) {
    return 'YESTERDAY';
  }

  return formatDistance(new Date(date), new Date(), { addSuffix: true });
}

function openResource() {
  emit('open-resource', props.notification);
}

return { __sfc: true,props, emit, notificationTitle, isFileExportedNotification, formatDate, openResource, NotificationAlertType, MaterialIcon }
}

})